export default __webpack_public_path__ + "static/media/receiver.93bf999a.svg";